import * as types from '../mutation-types'
import folder from '../../api/folder'

var folderTemplate = {
    id: null,
    name: "Root",
    num_files: 0,
    buildingId: null,
    updatedAt: "2018-08-12T03:53:37+00:00",
    breadcrumbs: []
};

// state
export const state = {
    folderId: null,
    buildingId: null,
    searchTerm: '',
    detailsView: true,

    folders: [],
    files: [],
}

// getters
export const getters = {
    currentFolder: (state, getters) => {
        if (typeof(state.folders) != 'undefined') {
            if (getters.isSearch) {
                var folder = folderTemplate;
                folder.name = 'Search for "'+state.searchTerm+'"';
                return folder;
            } else {
                const folderId = state.folderId;
                const folders = state.folders.filter((f) => f.id == folderId);
                if (folders.length > 0) {
                    return folders.pop();
                }
            }
        }
        return folderTemplate;
    },

    currentBreadcrumbs: (state, getters) => {
        if (getters.isSearch) {
            return [getters.currentFolder]
        }
        return getters.currentFolder.breadcrumbs
    },

    subFolders: (state, getters) => {
        if (typeof(state.folders) != 'undefined') {
            const folderId = state.folderId;

            return state.folders.filter((f) => {
                if (getters.isSearch) {
                    return f.name.toLowerCase().includes(getters.caseInsensitiveTerm);
                } else {
                    return f.parentId == folderId
                }
            });
        }
        return [];
    },

    folderFiles: (state, getters) => {
        if (typeof(state.folders) != 'undefined') {
            const folderId = state.folderId;

            return state.files.filter((f) => {
                if (getters.isSearch) {
                    return f.name.toLowerCase().includes(getters.caseInsensitiveTerm);
                } else {
                    return f.folderId == folderId
                }
            });
        }
        return [];
    },

    isSearch: (state) => state.searchTerm != '',
    caseInsensitiveTerm: (state) => state.searchTerm.toLowerCase(),
}

// mutations
export const mutations = {
    [types.SET_FOLDER_DETAIL](state, data) {
        state.folders = data.folders;
        state.files = data.files;
    },

    [types.SET_FOLDER_VIEW_DETAIL](state) {
        state.detailsView = true;
    },

    [types.SET_FOLDER_VIEW_LARGE](state) {
        state.detailsView = false;
    },

    [types.SET_CURRENT_FOLDER](state, data) {
        if (data.folderId == 0) {
            state.folderId = null;
        } else {
            state.folderId = data.folderId;
        }

        state.buildingId = data.buildingId;

        if (typeof(data.searchTerm) != 'undefined') {
            state.searchTerm = data.searchTerm;
        } else {
            state.searchTerm = '';
        }
    },
}

// actions
export const actions = {
    getDetail ({commit, state}, payload) {
        let {buildingId, folderId, searchTerm, force} = payload;

        if (typeof(force) == 'undefined') {
            force = false;
        }

        if (buildingId != state.buildingId || force) {
            folder.getFolderDetail(buildingId, (folders, files) => {
                commit(types.SET_FOLDER_DETAIL, {
                    'folders': folders,
                    'files': files
                })
            })
        }

        commit(types.SET_CURRENT_FOLDER, payload)
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/folder.js